import _Descriptions from './Descriptions';

import './style/index.js';

export type { DescriptionsProps } from './Descriptions';

export const Descriptions = _Descriptions;

export default Descriptions;
